import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 4,
	height: 16,
	viewBox: "0 0 4 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 2C4 0.90625 3.09375 0 2 0C0.875 0 0 0.90625 0 2C0 3.125 0.875 4 2 4C3.09375 4 4 3.125 4 2ZM4 8C4 6.90625 3.09375 6 2 6C0.875 6 0 6.90625 0 8C0 9.125 0.875 10 2 10C3.09375 10 4 9.125 4 8ZM4 14C4 12.9062 3.09375 12 2 12C0.875 12 0 12.9062 0 14C0 15.125 0.875 16 2 16C3.09375 16 4 15.125 4 14Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgEllipsisVertical);
export { ForwardRef as ReactComponent };
